import styled from '@emotion/styled';

export type AlertVariant = 'red' | 'green' | 'yellow' | 'blue' | 'purple';

type Props = {
  color: AlertVariant;
};

export const AlertBox = styled('div')<Props>`
  text-align: left;
  border-left: 5px solid ${(p) => p.theme.custom.colors[p.color].w500};
  margin: ${(p) => p.theme.spacing()}px 0;
  padding: ${(p) => p.theme.spacing(2)}px;
  border-radius: ${(p) => p.theme.custom.border.radius()}px;
  background-color: ${(p) => p.theme.custom.colors[p.color].w200};
  font-family: ${(p) => p.theme.typography.fontFamily};
  font-size: ${(p) => p.theme.typography.body2.fontSize};
  line-height: ${(p) => p.theme.typography.body2.lineHeight};
  width: 100%;
`;

export const CardAlertBox = styled(AlertBox)`
  border-left: none;
  margin: 0;
  border-radius: 0;
`;
